import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @Input() rol: any;
  @Input() asistenciaMesa: number;
  @Input() totalEsperados: number;
  @Input() totalAsistencias: number;
  @Input() pendientes: number;
  @Input() porcentaje: any;
  @Input() presenciales: number;
  @Input() representados: number;
 

  constructor() { }

  ngOnInit(): void {

  }

}
